import { useMemo, useState } from 'react'

import { useLocales } from 'src/contexts'

import { useConvertCurrency } from 'src/hooks/useConvertCurrency'
import { useAppSelector } from 'src/hooks/useAppSelector'
import { useAppDispatch } from 'src/hooks/useAppDispatch'

import { CURRENCIES } from 'src/features/UserCurrency/constants'

import { userSlice } from 'src/store/reducers/UserReducer/UserSlice'

export const useSelectCurrencyInput = () => {
  const { translations } = useLocales()

  const { currency } = useAppSelector(state => state.user)
  const { setCurrency } = userSlice.actions
  const dispatch = useAppDispatch()

  const { dataCurrency } = useConvertCurrency()

  const [open, setOpen] = useState(false)
  const [value, setValue] = useState(currency || '')

  function handleCurrencyChange(currency: string): void {
    dispatch(setCurrency(currency))
  }

  function onSelectCurrency(currency: string): void {
    setValue(currency)
    handleCurrencyChange(currency)
    setOpen(false)
  }

  const listOfCurrencies = useMemo(() => {
    return Object.keys(dataCurrency).slice(1)
  }, [dataCurrency])

  return {
    locale: translations.setting,
    currency,
    open,
    setOpen,
    value,
    onSelectCurrency,
    listOfCurrencies: listOfCurrencies || CURRENCIES,
  }
}
